import NahlasenieChyby from './NahlasenieChyby';

export default NahlasenieChyby;
